import { ComponentData, ComponentMetadata, ErrorConfigForm } from '@/types/automated-scenarios';
import { i18n } from '@/i18n';
// eslint-disable-next-line import/no-cycle
import {
  AutomatedScenarioState as state,
  getOperatorChildByOutput,
  isRootOfTree,
} from '@/composables/AutomatedScenarios';
import { TypeCampaignEnum } from '@/types';

export interface DeclencheurRegisterOnSiteData {
  nothing: string;
}

let translation: any;
(async () => {
  translation = await i18n;
})();

const DeclencheurRegisterOnSiteMetadata: ComponentMetadata<DeclencheurRegisterOnSiteData> = {
  Meta: {
    kind: 'declencheur',
    id: 'registeronsite',
    label: 'automatedScenarios.triggers.registerOnSite.label',
    icon: 'fa-user-plus',
    hasConfiguration: false,
    incompatibilities: {
      automation: {
        next_operators: [
          'boxabandonpanier', 'boxperiodiclaunching', 'boxscrollpage',
          'boxstatuscommand', 'registeronsite', 'subscribetonewsletter',
          'boxtag', 'boxlist', 'boxfiltre_2',
          'boxfiltre_4', 'openemail', 'clicklink',
        ],
      },
    },
    component: 'DeclencheurRegisterOnSite',
    availableInCampaign: [TypeCampaignEnum.AUTOMATION],
  },
  Create({ nothing }: DeclencheurRegisterOnSiteData = {
    nothing: '',
  }): ComponentData<DeclencheurRegisterOnSiteData> {
    return {
      id: 'registeronsite',
      form_name: 'registeronsite',
      logo_box: 'fa-user-plus',
      nothing,
    };
  },
  async Validate(data: DeclencheurRegisterOnSiteData): Promise<ErrorConfigForm> {
    return {
      success: true,
    };
  },
  Outputs(data: DeclencheurRegisterOnSiteData): number {
    return 1;
  },
  CanBeDeleted(operatorId: string): boolean|string {
    const isRoot = isRootOfTree(operatorId);

    if (isRoot) {
      const childOperator = getOperatorChildByOutput(operatorId, 'output_1');
      if (childOperator !== null && typeof (state.scenario.data.operators[childOperator]) !== undefined
        && state.scenario.data.operators[childOperator].properties.class !== 'declencheur') {
        return 'automatedScenarios.cant_remove_operator';
      }
    }

    return true;
  },
  Label(data: DeclencheurRegisterOnSiteData): string {
    return translation.global.t('automatedScenarios.triggers.registerOnSite.label');
  },
};

export default DeclencheurRegisterOnSiteMetadata;
